/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Oversight_RequiredInputs */

const en_deep_match_oversight_required = /** @type {(inputs: Deep_Match_Oversight_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm you understand the score is AI-assisted before analyzing.`)
};

const de_deep_match_oversight_required = /** @type {(inputs: Deep_Match_Oversight_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte bestätigen Sie, dass Sie verstehen, dass die Bewertung KI-gestützt ist, bevor Sie analysieren.`)
};

const fr_deep_match_oversight_required = /** @type {(inputs: Deep_Match_Oversight_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm you understand the score is AI-assisted before analyzing.`)
};

const es_deep_match_oversight_required = /** @type {(inputs: Deep_Match_Oversight_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm you understand the score is AI-assisted before analyzing.`)
};

const it_deep_match_oversight_required = /** @type {(inputs: Deep_Match_Oversight_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm you understand the score is AI-assisted before analyzing.`)
};

const nl_deep_match_oversight_required = /** @type {(inputs: Deep_Match_Oversight_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm you understand the score is AI-assisted before analyzing.`)
};

const pl_deep_match_oversight_required = /** @type {(inputs: Deep_Match_Oversight_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm you understand the score is AI-assisted before analyzing.`)
};

const fi_deep_match_oversight_required = /** @type {(inputs: Deep_Match_Oversight_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm you understand the score is AI-assisted before analyzing.`)
};

const da_deep_match_oversight_required = /** @type {(inputs: Deep_Match_Oversight_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm you understand the score is AI-assisted before analyzing.`)
};

const sv_deep_match_oversight_required = /** @type {(inputs: Deep_Match_Oversight_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm you understand the score is AI-assisted before analyzing.`)
};

/**
* | output |
* | --- |
* | "Please confirm you understand the score is AI-assisted before analyzing." |
*
* @param {Deep_Match_Oversight_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_oversight_required = /** @type {((inputs?: Deep_Match_Oversight_RequiredInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Oversight_RequiredInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_oversight_required(inputs)
	if (locale === "fr") return fr_deep_match_oversight_required(inputs)
	if (locale === "es") return es_deep_match_oversight_required(inputs)
	if (locale === "it") return it_deep_match_oversight_required(inputs)
	if (locale === "nl") return nl_deep_match_oversight_required(inputs)
	if (locale === "pl") return pl_deep_match_oversight_required(inputs)
	if (locale === "fi") return fi_deep_match_oversight_required(inputs)
	if (locale === "da") return da_deep_match_oversight_required(inputs)
	if (locale === "sv") return sv_deep_match_oversight_required(inputs)
	return en_deep_match_oversight_required(inputs)
});